// Reconstructed from the supplied production build; original component names were unavailable.
import { React } from "../../vendor/runtime.js";
const VerifyOtpInput = ({ length: a = 6, value: n, onChange: i, error: l }) => {
  const [c, u] = React.useState(new Array(a).fill("")),
    m = React.useRef([]);
  React.useEffect(() => {
    n !== c.join("") && u(n.split("").concat(new Array(a).fill("")).slice(0, a));
  }, [n, a]);
  const f = (g, b) => {
      if (isNaN(g.value)) return;
      const y = [...c];
      ((y[b] = g.value), u(y), i(y.join("")), g.value && b < a - 1 && m.current[b + 1].focus());
    },
    x = (g, b) => {
      if (g.key === "Backspace" && !c[b] && b > 0) {
        const y = [...c];
        ((y[b - 1] = ""), u(y), i(y.join("")), m.current[b - 1].focus());
      }
    },
    p = (g) => {
      g.preventDefault();
      const b = g.clipboardData.getData("text/plain").slice(0, a);
      if (/^\d+$/.test(b)) {
        const y = b.split("").concat(new Array(a).fill("")).slice(0, a);
        (u(y), i(b));
        const w = Math.min(b.length, a - 1);
        m.current[w].focus();
      }
    };
  return (
    <div className={"flex justify-center gap-1.5 sm:gap-3 mb-4 sm:mb-6"}>
      {c.map((g, b) => (
        <input
          key={b}
          ref={(y) => (m.current[b] = y)}
          type={"text"}
          maxLength={"1"}
          value={g}
          onChange={(y) => f(y.target, b)}
          onKeyDown={(y) => x(y, b)}
          onPaste={p}
          className={`w-8 h-10 sm:w-12 sm:h-14 md:w-14 md:h-16 text-center text-base sm:text-xl md:text-2xl font-bold bg-gray-50 border-2 rounded-md sm:rounded-lg transition-all duration-300 focus:outline-none focus:bg-white focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-20 hover:bg-gray-100 ${l ? "border-red-500 bg-red-50" : "border-gray-200"} ${g ? "border-indigo-400 bg-indigo-50 text-indigo-700" : ""}`}
        />
      ))}
    </div>
  );
};
export { VerifyOtpInput };
